<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div style="margin-bottom: 24px;">
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加奖品</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="displayName"
            label="显示名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="imageUrl"
            label="图标">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;height: 40px;border-radius: 40px;"
                :src="scope.row.imageUrl"
                :preview-src-list="[scope.row.imageUrl]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="prizeType"
            label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType === 1">优惠券</span>
              <span v-else-if="scope.row.prizeType === 2">积分</span>
              <span v-else-if="scope.row.prizeType === 3">商品</span>
              <span v-else>未中奖</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityPrizeName"
            label="奖品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="winProbability"
            label="概率（%）">
          </el-table-column>
          <el-table-column
            align="center"
            prop="winProbability"
            label="投放数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="receiveQuantity"
            label="领取数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryLotteryActivityPrizePageList, removeLotteryActivityPrizeById } from '@/api/prizeDraw'
export default {
  name: 'PrizeDrawManage',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let page = that.currentPage
      let dataId = this.dataId;
      queryLotteryActivityPrizePageList({ activityConfigId: dataId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 编辑 */
    editBtn (infoId) {
      var that = this;
      this.$router.push({path: '/prize_draw_manage_add', query: {dataId: infoId, activityConfigId: that.dataId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeLotteryActivityPrizeById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/prizeDraw/PrizeDrawManage.vue